"use client";
import { Suspense } from "react";
import "../terms/Terms.scss";

export default function Statement() {
  return (
    <Suspense>
      <div className="statement-main-container">
        <h1>CelebStory 2257</h1>
        <div className="text-container">
          <p>
            18 U.S.C. 2257 Records Keeping Requirements Compliance Statement
          </p>
          <p>
            CelebStory.com is not the "producer" of the content found on the
            website CelebStory.com. With respect to the records as per 18 U.S.C.
            2257 for any and all content found on this website, direct your
            request to the site for which the content was produced.
          </p>

          <p>
            CelebStory.com is a video/image sharing site in which allows for the
            viewing, uploading, and sharing various types of content.
          </p>

          <p>
            Should any content be unlawful or illegal, CelebStory.com will
            remove it as soon as possible. Users of CelebStory.com who come
            across such content are urged to report it as inappropriate by
            contacting us.
          </p>

          <p>
            For further assistance/information in finding the content's
            originating site or to report content, please use the “Report”
            button at the content’s page; or send the message to
            Admin@celebstory.com
          </p>
        </div>
      </div>
    </Suspense>
  );
}
